import { FormControl, Grid, InputLabel, MenuItem, StandardTextFieldProps, TextField, Typography } from "@mui/material"
import { Industry } from "../../Types/General"

interface KaziIndustriesProps extends StandardTextFieldProps {
    showLabel?: boolean;
}
export const KaziIndustries = (props: KaziIndustriesProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid display={'flex'} flexDirection={'column'} width={'100%'} flex={1}>
            {props.showLabel && <Typography variant='body-small' color={'black.200'} marginBottom={1}>Industry</Typography>}
            <FormControl>   
                <InputLabel sx={{opacity: 1, color: 'primary.main'}}>{props.value ?"":"Industry"}</InputLabel>
                <TextField
                    select
                    {...props}
                >
                    {
                        Industry.map((industry) => (
                            <MenuItem key={industry} value={industry}>
                                {industry}
                            </MenuItem>
                        ))
                    }
                </TextField>
            </FormControl>
        </Grid>
    )
}